import { type GenericMap, type MegaMenuItemOptions, type MenuItem } from "@client/types";
import { ScreenType } from "@client/types/Enums";

export const getMegaOptions = (
  item: MenuItem,
  settings: GenericMap<any>,
  screen: ScreenType
): MegaMenuItemOptions | undefined => {
  // const iterable = iterateDynamic(settings, "megaMenuEnable");

  // for (let index of iterable) {
  // if (isOn(settings[`megaMenuEnable${index}`], screen)) {
  //   const mmTabName = normalizeText(settings[`mmTabName${index}`], screen);
  //   if (!mmTabName || item.name.toLowerCase() !== mmTabName.toLowerCase()) continue;

  //   return {
  //     align: normalizeDropdown(settings[`megaMenuHorizontalAlign${index}`], screen) as HorizontalAlign,
  //     columns: +normalizeDropdown(settings[`megaMenuColumns${index}`], screen)!,
  //     content: normalizeDropdown(settings[`megaMenuContent${index}`], screen),
  //     sorting: <MegaMenuSortingType>normalizeDropdown(settings[`megaMenuSorting${index}`], screen)
  //   };
  // }

  return;
  // }
};
